import type { Action } from 'redux'
import type { ApiResponse } from '../../../../../config/api-types'
import { LOGOUT } from '../../../../authentication/presentation/redux/types/log-out-types'
import * as types from '../types/create-collection-order-types'

export const InitialCreateCollectionOrder = {
  data: null as unknown as ApiResponse as any,
  load: false,
  error: '',
}

export const createCollectionOrderReducer = (
  state = InitialCreateCollectionOrder,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }
  switch (action.type) {
    case types.CREATE_COLLECTION_ORDER_REQUEST:
      newState.load = true
      return newState

    case types.CREATE_COLLECTION_ORDER_ERROR:
      newState.load = false
      newState.error = action.payload
      return newState

    case types.CREATE_COLLECTION_ORDER_SUCCESS:
      newState.load = false
      newState.error = ''
      newState.data = action.payload
      return newState

    case types.CREATE_COLLECTION_ORDER_RESET:
      return InitialCreateCollectionOrder

    case LOGOUT:
      return InitialCreateCollectionOrder

    default:
      return { ...state }
  }
}
